import { EmptyControl, Required } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrDateConflictControlModel')
export class DateConflictControlModel{
    @JsonProperty('hrmTypeUuid', String, true)
    hrmTypeUuid: string = null;

    @Required()
    @JsonProperty('peopleId', Number, true)
    peopleId: number = null;

    @JsonProperty('id', Number, true)
    id: number = null;

    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

}
